// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xItemReplacements from "@guestsupply/App/Handlers/XNG/ItemReplacements";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    itemReplacements: state.xItemReplacements,
});

const mapDispatchToProps = {
    xItemReplacements,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & HasProductContext & ReturnType<typeof mapStateToProps>;

export interface ItemReplacementsStyles {
    availableOptionsLink?: LinkPresentationProps;
}

export const itemReplacementsStyles: ItemReplacementsStyles = {};

const styles = itemReplacementsStyles;

const ItemReplacements: FC<Props> = ({ productContext, xItemReplacements, itemReplacements }) => {
    const { product } = productContext;

    if (!product || !itemReplacements[product.id]?.carouselItemReplacement) {
        return null;
    }

    const handleitemReplacementsClick = () => {
        xItemReplacements({
            id: productContext.product.id,
            value: {
                productItemReplacement: true,
            },
        });
    };

    return (
        <Link onClick={handleitemReplacementsClick} {...styles.availableOptionsLink} id="available-options-button">
            {translate("See Available Options")}
        </Link>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ItemReplacements));
